
import reduxCreator from '../libs/mk-womanizer/redux-creator';
import axiosPlugin from "../libs/mk-womanizer/ac-axios-plugin";


let redux = reduxCreator.type('HOME_MEDIAS_CREATOR').plugin(axiosPlugin, {template: "array"});

let fetchHomeMediasCreatorAction = redux.fetchActionGet();

export const fetchHomeMediasCreator = () => fetchHomeMediasCreatorAction(`/features/medias-creator`);

export const homeMediaCreator = redux.reducer();